module.exports = __webpack_public_path__ + "static/media/kudos-prev.7afbc703.svg";